

import "./aesthetic.css";

import Header from "../../../components/Header";    
import Footer from "../../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";


export default function Aesthetic() {


    return(

        <div className="context">
        
            <Header access={1}></Header>
        
            <div className="content">



            <div className="space"></div>
            <div className="space"></div>
            <div className="space"></div>
         
            </div>
        
        <Footer access={1}></Footer>
        
        </div>
    )
}